import { forwardRef } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

export const useTipoArchivo = () => {
  const tiposArchivos = {
    documentacion: [
      {
        iddocumentacion: 2,
        descripcion: 'Historia Clínica actualizada',
        codigo: '2',
        activo: true,
        observacion: '',
      },
      {
        iddocumentacion: 4,
        descripcion: 'Resultado de Estudios',
        codigo: '4',
        activo: true,
        observacion: '',
      },
    ],
  };

  return {
    loading: false,
    options: tiposArchivos.documentacion,
  };
};

/**
 * @typedef {Object} TipoArchivoAutocomplete
 * @property {Object} value - recibe como valor el objeto Practica para setear en la lista, si se encuentra.
 * @property {Object} error - si se recibe el objeto de error entonces se esta indicante ese mismo estado {message}.
 * @property {function} onChangeEvent - Función que se ejecuta cuando cambia la selección.
 */

/**
 * @param {TipoArchivoAutocomplete} props
 */
export const TipoArchivoAutocomplete = forwardRef(
  ({ value, error, onChangeOption, ...props }, ref) => {
    const { loading, options } = useTipoArchivo();

    const handleChange = (newValue) => {
      if (onChangeOption) {
        onChangeOption(newValue);
      }
    };

    return (
      <Autocomplete
        {...props}
        ref={ref}
        value={value || null}
        isOptionEqualToValue={(option, val) => option.codigo === val.codigo}
        getOptionLabel={(option) => `${option.descripcion}`}
        loading={loading}
        options={options}
        onChange={(_, newValue) => handleChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={'Tipo de archivo'}
            variant='standard'
            error={!!error}
            helperText={error ? error.message : ''}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color='inherit' size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    );
  },
);
